import { EtatDocumentPa } from "./document-pa.entity";

export class UpdateStepDefinitionOrder {

	id!: number;
	dateDebut!: Date | null;
	dateFin!: Date | null;
	duree!: number;
	horaires!: string;
	nombreIntervenants!: number;
	description!: string;
	etat!: EtatDocumentPa;
	
	numeroPa!: string;
	commune!: string;
	parcIds: number[] = [];
	responsableId!: number;
	lastCompletedStep!: number;
	
}
